import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Nav, Badge as BsBadge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { LOPDAOTAOLIENTUC_API, DONVI_API, DOTTUYENSINH_API, DOITUONG_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    messageToast, 
    objectShowNumber, 
    status200,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../../../utils/define';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import ChiTietLopDaoTaoLienTucModal from './ChiTietLopDaoTaoLienTucModal';
import ThanhToanLePhiModal from '../thanhToanLePhi/ThanhToanLePhiModal';

const LopDaoTaoLienTuc = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [namKhaiGiang, setNamKhaiGiang] = useState(new Date().getFullYear());
    const [selectedRow, setSelectedRow] = useState(null);
    const queryClient = useQueryClient();

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModalChiTiet, setOpenModalChiTiet] = useState(false);
    const [dataChiTiet, setDataChiTiet] = useState(null);

    const [openModalThanhToan, setOpenModalThanhToan] = useState(false);
    const [entityThanhToanId, setEntityThanhToanId] = useState('');
    const [entityThanhToanName, setEntityThanhToanName] = useState('');

    const handleOpenModalChiTiet = (item) => {
        setDataChiTiet(item);
        setOpenModalChiTiet(true);
    };

    const handleCloseModalChiTiet = () => {
        setOpenModalChiTiet(false);
        setDataChiTiet(null);
    };

    const handleOpenModalThanhToan = (id, name) => {
        setEntityThanhToanId(id);
        setEntityThanhToanName(name);
        setOpenModalThanhToan(true);
    };

    const handleCloseModalThanhToan = () => {
        setOpenModalThanhToan(false);
        setEntityThanhToanId('');
        setEntityThanhToanName('');
    };

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('nam') != null && parseInt(paramUrl.get('nam'), 10) !== namKhaiGiang) {
        setNamKhaiGiang(parseInt(paramUrl.get('nam'), 10));
    }

    const replaceHistory = (Page, Size, Search, Nam) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.LOPDAOTAOLIENTUC_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['lopDaoTaoLienTucData', valueSearch, page, pageSize, namKhaiGiang],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamKhaiGiang: namKhaiGiang
            };
            replaceHistory(page, pageSize, valueSearch, namKhaiGiang);
            return Get(LOPDAOTAOLIENTUC_API.GET_PAGING, null, model);
        },
        { keepPreviousData: true }
    );

    const { data: donViData } = useQuery(
        ['donViDataLopLienTuc'],
        () => Get(DONVI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );

    const listDonVi = donViData?.data?.$values || donViData?.data || [];

    const { data: doiTuongData } = useQuery(
        ['doiTuongDataLopLienTuc'],
        () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDoiTuong = doiTuongData?.data?.$values || doiTuongData?.data || [];

    const { data: listNamData } = useQuery(
        ['listNamKhaiGiangLienTuc'],
        () => Get(LOPDAOTAOLIENTUC_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );
    const rawListNam = (Array.isArray(listNamData) ? listNamData : listNamData?.$values) || [];
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namKhaiGiang)) {
            const maxYear = Math.max(...rawListNam);
            setNamKhaiGiang(maxYear);
            replaceHistory(1, pageSize, search, maxYear);
        }
    }, [listNamData, namKhaiGiang]);

    useEffect(() => {
        refetch();
    }, [pageSize, page, namKhaiGiang]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namKhaiGiang);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namKhaiGiang);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namKhaiGiang);
    };

    const onChangeNamKhaiGiang = (e) => {
        const nam = Number(e.target.value);
        setNamKhaiGiang(nam);
        setPage(1);
        replaceHistory(1, pageSize, search, nam);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(LOPDAOTAOLIENTUC_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    queryClient.invalidateQueries(['lopDaoTaoLienTucData']);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => item.id === prev.id);
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [data]);

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const getDonViName = (id) => {
        if (!id) return '';
        const found = listDonVi.find(x => x.id === id);
        return found ? found.tenDonVi : id;
    };

    const getChucDanhName = (idsStr) => {
        if (!idsStr) return '';
        const ids = idsStr.split(',').map(id => id.trim());
        const names = ids.map(id => {
            const cd = listDoiTuong.find(item => item.id === id);
            return cd ? cd.tenDoiTuong : '';
        }).filter(name => name !== '');
        return names.join(', ');
    };

    const getTrangThaiBadge = (val) => {
        let variant = 'secondary';
        if (val === trangThaiDotTuyenSinhValue.sapMo) variant = 'warning';
        else if (val === trangThaiDotTuyenSinhValue.dangMo) variant = 'success';
        else if (val === trangThaiDotTuyenSinhValue.daDong) variant = 'danger';
        else if (val === trangThaiDotTuyenSinhValue.tamDung) variant = 'secondary';
        
        const label = objectTrangThaiDotTuyenSinh.find(x => x.value === val)?.label || 'Không xác định';
        return <BsBadge variant={variant}>{label}</BsBadge>;
    };

    return (
        <div className="container-fluid">
            <Card className="card-layout-full">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.DOTTUYENSINH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOLIENTUC_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namKhaiGiang} onChange={onChangeNamKhaiGiang} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                            <NavLink to={URI_INTERNAL.LOPDAOTAOLIENTUC_CREATE_PATH} className="btn btn-success ml-3">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead className="text-nowrap">
                                <tr>
                                    <th>STT</th>
                                    <th>Tên khóa học</th>
                                    <th>Khoa đề xuất</th>
                                    <th>Loại tuyển sinh</th>
                                    <th>Số thông báo tuyển sinh</th>
                                    <th>Thời gian</th>
                                    <th>Số lượng HV</th>
                                    <th>Học phí</th>
                                    <th>Chức danh</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th style={{ minWidth: '120px' }}>Thời gian học</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={11}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={11}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={11}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.tenKhoaHoc}</td>
                                            <td>{getDonViName(item.khoaDeXuatId)}</td>
                                            <td>{getLabelFromEnum(item.loaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</td>
                                            <td>{item.soQuyetDinh}</td>
                                            <td>{item.thoiGianKhoaHoc ? `${item.thoiGianKhoaHoc} tháng` : ''}</td>
                                            <td>{item.soLuongHocVien}</td>
                                            <td>{new Intl.NumberFormat('vi-VN').format(item.hocPhi ?? 0)}</td>
                                            <td>{getChucDanhName(item.doiTuongIds)}</td>
                                            <td className="text-center">{getTrangThaiBadge(item.trangThaiDotTuyenSinh)}</td>
                                            <td style={{ minWidth: '120px' }}>
                                                {item.ngayKhaiGiang && moment(item.ngayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)} 
                                                {' - '}
                                                <br />
                                                {item.ngayBeGiang && moment(item.ngayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3 p-2">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        goBackAfterDelete={false}
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />

                    <ChiTietLopDaoTaoLienTucModal
                        isOpen={openModalChiTiet}
                        onClose={handleCloseModalChiTiet}
                        data={dataChiTiet}
                        getDonViName={getDonViName}
                        getChucDanhName={getChucDanhName}
                    />

                    <ThanhToanLePhiModal
                        isOpen={openModalThanhToan}
                        onClose={handleCloseModalThanhToan}
                        entityId={entityThanhToanId}
                        entityName={entityThanhToanName}
                        entityType="LopDaoTaoLienTuc"
                    />
                </Card.Body>
                {!isLoading && (
                    <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        <Button
                            variant="info"
                            size="sm"
                            className="mr-2"
                            disabled={!selectedRow}
                            onClick={() => handleOpenModalChiTiet(selectedRow)}>
                            <i className="fas fa-eye mr-1"></i> Xem chi tiết
                        </Button>
                        <Button
                            variant="warning"
                            size="sm"
                            className="mr-2 text-white"
                            disabled={!selectedRow}
                            onClick={() => handleOpenModalThanhToan(selectedRow?.id, selectedRow?.tenKhoaHoc)}>
                            <i className="fas fa-credit-card mr-1"></i> Thanh toán
                        </Button>
                        <Button
                            variant="primary"
                            size="sm"
                            className="mr-2"
                            disabled={!selectedRow}
                            onClick={() => history.push(`${URI_INTERNAL.LOPDAOTAOLIENTUC_EDIT_PATH}?id=${selectedRow?.id}`)}>
                            <i className="fas fa-edit mr-1"></i> Sửa
                        </Button>
                        <Button
                            variant="danger"
                            size="sm"
                            disabled={!selectedRow}
                            onClick={() => deleteAction(selectedRow?.id, selectedRow?.tenKhoaHoc)}>
                            <i className="fas fa-trash mr-1"></i> Xóa
                        </Button>
                    </div>
                </Card.Footer>
                )}
            </Card>
        </div>
    );
};

export default LopDaoTaoLienTuc;